import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

const BusinessAddressFormMarketingContent = () => {
  const { formatMessage } = useIntl()

  return (
    <MarketingContent
      image={{
        alt: formatMessage({
          defaultMessage:
            'two women having fun at an office table, collaborating while a third woman is checking in and joining in on the fun.',
          id: 'sputnik.BusinessAddressFormMarketingContent__hS2Ox4',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-business-address-marketing-content.png',
        isRounded: true,
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Testimonial'
          id='sputnik.BusinessAddressFormMarketingContent__MvBefC'
        />
      }
    >
      <MarketingQuote
        designation={
          <FormattedMessage
            defaultMessage='Artemis Health'
            id='sputnik.BusinessAddressFormMarketingContent__nb+Xtd'
          />
        }
        name={
          <FormattedMessage
            defaultMessage='Steve Plowman'
            id='sputnik.BusinessAddressFormMarketingContent__XNexR4'
          />
        }
        quote={
          <FormattedMessage
            defaultMessage='“{BILL_SPEND_AND_EXPENSE} has increased efficiency for our firm. We have been able to <strong>reduce month end close processes by nearly 2 hours per client</strong>.”'
            id='sputnik.BusinessAddressFormMarketingContent__Irr3WA'
            values={{
              strong: (chunk) => <b key='bold'>{chunk}</b>,
              BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
            }}
          />
        }
      />
    </MarketingContent>
  )
}

export default BusinessAddressFormMarketingContent
